export default {
    boldChar(letter) {
        if (letter >= 'a' && letter <= 'z') {
          return String.fromCharCode(55349, 56717 + letter.charCodeAt(0));
        } else if (letter >= 'A' && letter <= 'Z') {
          return String.fromCharCode(55349, 56723 + letter.charCodeAt(0));
        } else if (letter >= '0' && letter <= '9') {
          return String.fromCharCode(55349, 57276 + letter.charCodeAt(0));
        } else if (letter >= 'à' && letter <= 'ã') {
          return String.fromCharCode(55349, 56814 , 544 + letter.charCodeAt(0)) 
        } else if (letter >= 'è' && letter <= 'ê') {
          return String.fromCharCode(55349, 56818 , 536 + letter.charCodeAt(0))
        } else {
          switch (letter) {
            case 'ë': return '𝗲̈';
            case 'î': return '𝗶̂';
            case 'ï': return '𝗶̈';
            case 'ô': return '𝗼̂';
            case 'ù': return '𝘂̀';
            case 'ú': return '𝘂́';
            case 'û': return '𝘂̂';
            case 'ü': return '𝘂̈';
            case 'ç': return '𝗰̧';
            case 'ñ': return '𝗻̃';
            default: return letter;
          }
        }
    },

    italicChar(letter) {
        if (letter >= 'a' && letter <= 'z') {
          return String.fromCharCode(55349, 56769 + letter.charCodeAt(0));
        } else if (letter >= 'A' && letter <= 'Z') {
          return String.fromCharCode(55349, 56775 + letter.charCodeAt(0));
        } else if (letter >= 'à' && letter <= 'ã') {
          return String.fromCharCode(55349, 56866 , 544 + letter.charCodeAt(0)) 
        } else if (letter >= 'è' && letter <= 'ê') {
          return String.fromCharCode(55349, 56870 , 536 + letter.charCodeAt(0))
        } else {
          switch (letter) {
            case 'ë': return '𝘦̈';
            case 'ô': return '𝘰̂';
            case 'ù': return '𝘶̀';
            case 'ú': return '𝘶́';
            case 'û': return '𝘶̂';
            case 'ü': return '𝘶̈';
            case 'ç': return '𝘤̧';
            case 'ñ': return '𝘯̃';
            default: return letter;
          }
        }
    },

    underlineChar(letter) {
        return String.fromCharCode(...letter.split('').map(e => e.charCodeAt(0)), 863);
      },
  
      boldItalicChar(letter) {
        if (letter >= 'a' && letter <= 'z') {
          return String.fromCharCode(55349, 56821 + letter.charCodeAt(0));
        } else if (letter >= 'A' && letter <= 'Z') {
          return String.fromCharCode(55349, 56827 + letter.charCodeAt(0));
        } else if (letter >= '0' && letter <= '9') {
          return String.fromCharCode(55349, 57276 + letter.charCodeAt(0));
        } else if (letter >= 'à' && letter <= 'ã') {
          return String.fromCharCode(55349, 56918 , 544 + letter.charCodeAt(0)) 
        } else if (letter >= 'è' && letter <= 'ê') {
          return String.fromCharCode(55349, 56922 , 536 + letter.charCodeAt(0))
        } else {
          switch (letter) {
            case 'ë': return '𝙚̈';
            case 'î': return '𝗶̂';
            case 'ï': return '𝗶̈';
            case 'ô': return '𝙤̂';
            case 'ù': return '𝙪̀';
            case 'ú': return '𝙪́';
            case 'û': return '𝙪̂';
            case 'ü': return '𝙪̈';
            case 'ç': return '𝙘̧';
            case 'ñ': return '𝙣̃';
            default: return letter;
          }
        }
      },
  
      unboldChar(letter) {
        if (letter >= '𝗲̀' && letter <= '𝗲̂') {
          return String.fromCharCode(letter.charCodeAt(2) - 536);
        }  else if (letter >= '𝗮̀' && letter <= '𝗮̃') {
          return String.fromCharCode(letter.charCodeAt(2) - 544);
        } else if (letter >= '𝗮' && letter <= '𝘇') {
          return String.fromCharCode(letter.charCodeAt(1) - 56717);
        } else if (letter >= '𝗔' && letter <= '𝗭') {
          return String.fromCharCode(letter.charCodeAt(1) - 56723);
        } else if (letter >= '𝟬' && letter <= '𝟵') {
          return String.fromCharCode(letter.charCodeAt(1) - 57276);
        } else {
          switch (letter) {
            case '𝗲̈': return 'ë';
            case '𝗶̂': return 'î';
            case '𝗶̈': return 'ï';
            case '𝗼̂': return 'ô';
            case '𝘂̀': return 'ù';
            case '𝘂́': return 'ú';
            case '𝘂̂': return 'û';
            case '𝘂̈': return 'ü';
            case '𝗰̧': return 'ç';
            case '𝗻̃': return 'ñ';
            default: return letter;
          }
        }
    },
  
      unitalicChar(letter) {
         if (letter >= '𝘢̀' && letter <= '𝘢̃') {
          return String.fromCharCode(letter.charCodeAt(2) - 544);
        } else if (letter >= '𝘦̀' && letter <= '𝘦̂') {
          return String.fromCharCode(letter.charCodeAt(2) - 536);
        } else if (letter >= '𝘢' && letter <= '𝘻') {
          return String.fromCharCode(letter.charCodeAt(1) - 56769);
        } else if (letter >= '𝘈' && letter <= '𝘡') {
          return String.fromCharCode(letter.charCodeAt(1) - 56775);
        } else {
          switch (letter) {
            case '𝘦̈': return 'ë';
            case '𝘰̂': return 'ô';
            case '𝘶̀': return 'ù';
            case '𝘶́': return 'ú';
            case '𝘶̂': return 'û';
            case '𝘶̈': return 'ü';
            case '𝘤̧': return 'ç';
            case '𝘯̃': return 'ñ';
            default: return letter;
          }
        }
      },
  
      ununderlineChar(letter) {
        return letter.split('').slice(0,-1).join('')
      },
  
      unboldItalicChar(letter) {
        if (letter >= '𝙖̀' && letter <= '𝙖̃') {
          return String.fromCharCode(letter.charCodeAt(2) - 544);
        } else if (letter >= '𝙚̀' && letter <= '𝙚̂') {
          return String.fromCharCode(letter.charCodeAt(2) - 536);
        } else if (letter >= '𝙖' && letter <= '𝙯') {
          return String.fromCharCode(letter.charCodeAt(1) - 56821);
        } else if (letter >= '𝘼' && letter <= '𝙕') {
          return String.fromCharCode(letter.charCodeAt(1) - 56827);
        } else if (letter >= '𝟬' && letter <= '𝟵') {
          return String.fromCharCode(letter.charCodeAt(1) - 57276);
        } else {
          switch (letter) {
            case '𝙚̈': return 'ë';
            case '𝙤̂': return 'ô';
            case '𝗶̂': return 'î';
            case '𝗶̈': return 'ï';
            case '𝙪̀': return 'ù';
            case '𝙪́': return 'ú';
            case '𝙪̂': return 'û';
            case '𝙪̈': return 'ü';
            case '𝙘̧': return 'ç';
            case '𝙣̃': return 'ñ';
            default: return letter;
          }
        }
      },
  
  
      bold(text) {
        if(!text.length) return text
        let a = text.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).map((letter) => {
          switch(this.styledText(letter)) {
            case 'bold': return this.unboldChar(letter);
            case 'italic': return this.boldItalicChar(this.unitalicChar(letter));
            case 'bold-italic': return this.italicChar(this.unboldItalicChar(letter));
            case 'normal': return this.boldChar(letter);
  
            // case 'underline': return this.underlineChar(this.boldChar(this.ununderlineChar(letter)));
            case 'underline': return this.boldChar(this.ununderlineChar(letter));
            case 'bold-underline': return this.underlineChar(this.unboldChar(this.ununderlineChar(letter)));
            case 'italic-underline': return this.underlineChar(this.boldItalicChar(this.unitalicChar(this.ununderlineChar(letter))));
            case 'bold-italic-underline': return this.underlineChar(this.italicChar(this.unboldItalicChar(this.ununderlineChar(letter))));
            default: return letter;
          }
        }).join('');
        return a;
      },
  
      italic(text) {
        if(!text.length) return text
        return text.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).map((letter) => {
          switch(this.styledText(letter)) {
            case 'bold': return this.boldItalicChar(this.unboldChar(letter));
            case 'italic': return this.unitalicChar(letter);
            case 'bold-italic': return this.boldChar(this.unboldItalicChar(letter));
            case 'normal': return this.italicChar(letter);
  
            // case 'underline': return this.underlineChar(this.italicChar(this.ununderlineChar(letter)));
            case 'underline': return this.italicChar(this.ununderlineChar(letter));
            case 'bold-underline': return this.underlineChar(this.boldItalicChar(this.unboldChar(this.ununderlineChar(letter))));
            case 'italic-underline': return this.underlineChar(this.unitalicChar(this.ununderlineChar(letter)));
            case 'bold-italic-underline': return this.underlineChar(this.boldChar(this.unboldItalicChar(this.ununderlineChar(letter))));
            default: return letter;
          }
        }).join('');
      },
  
      underline(text) {
        if(!text.length) return text
        return text.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).map((letter) => {
          if (this.styledText(letter).includes('underline')) {
            return this.ununderlineChar(letter);
          } else {
            switch(this.styledText(letter)) {
              case 'bold': return this.underlineChar(this.unboldChar(letter));
              case 'italic': return this.underlineChar(this.unitalicChar(letter));
              case 'bold-italic': return this.underlineChar(this.unboldItalicChar(letter));
              default: return this.underlineChar(letter);
            }
          }
        }).join('');
      },

      normalize(text) {
        if(!text.length) return text
        return text.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).map((letter) => {
          switch(this.styledText(letter)) {
            case 'bold': return this.unboldChar(letter);
            case 'italic': return this.unitalicChar(letter);
            case 'underline': return this.ununderlineChar(letter);
            case 'bold-italic': return this.unboldItalicChar(letter);
            case 'bold-italic-underline': return this.unboldItalicChar(this.ununderlineChar(letter));
            case 'italic-underline': return this.unitalicChar(this.ununderlineChar(letter));
            case 'bold-underline': return this.unboldChar(this.ununderlineChar(letter));
            case 'normal': return letter;
            default: return letter;
          }
        }).join('');
      },

      styledText(str) {
        if (!str || str.trim().length === 0 || !str.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu)) return '';
        let underline = str.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).every(e => e.slice(-1).charCodeAt(0) == 863);
        if (str.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).every(e => this.unboldChar(e) !== e)) {
          return underline ? 'bold-underline' : 'bold';
        } else if (str.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).every(e => this.unitalicChar(e) !== e)) {
          return underline ? 'italic-underline' : 'italic';
        } else if (str.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu).every(e => this.unboldItalicChar(e) !== e)) {
          return underline ? 'bold-italic-underline' : 'bold-italic';
        } else {
          return underline ? 'underline' : 'normal';
        }
      },

      getWordAt(str, pos) {

        // Perform type conversions.
        str = String(str);
        pos = Number(pos) >>> 0;
    
        // Search for the word's beginning and end.
        var left = str.slice(0, pos + 1).search(/\S+$/),
            right = str.slice(pos).search(/\s/);
    
        // The last word in the string is a special case.
        if (right < 0) {
            return str.slice(left);
        }
    
        // Return the word, using the located bounds to extract it from the string.
        return str.slice(left, right + pos);
    
      },

      checkIfMention(str, start, end) {
        console.log(str, start, end);
        for (let i = start; i <= end; i++) {
          let a = this.getWordAt(str, i)
          console.log(a);
          if (a.match(/@\[MENTIONS-[0-9]+]/)) {
            return true;
          }
        }
        return false;
      },

      phpLenghtCompensation(str) {
        return Math.abs((new TextEncoder().encode(str)).length - str.length);
      }
}